<script setup lang="ts">
import { getAssetsUrlForCDN } from '@/utils/template';

// Badge central do Clube de Fidelidade (aparece só logado). Mesmo formato do
// HomeBadge (círculo azul elevado no bump da barra), mas com o logo do Clube e
// abre o hub em vez de navegar.
const store = useLoyaltyHubStore();

const logo = getAssetsUrlForCDN('/assets/images/loyalty-hub/badge-logo.png');

function onClick() {
  store.open();
}

// A badge só existe pra quem pode abrir o hub, então é o gatilho natural pra
// aquecer as artes do topo do painel — no ócio, sem disputar rede com a página.
// Sem isso a primeira abertura pedia header + cards na hora e o conteúdo ia
// aparecendo em cascata.
onMounted(() => {
  const warm = () => store.warmAssets();

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(warm, { timeout: 3000 });

    return;
  }

  // Safari antigo não tem requestIdleCallback.
  setTimeout(warm, 1500);
});
</script>

<template>
  <div
    class="badge-wrapper"
    @click="onClick"
  >
    <div class="badge">
      <div class="glow" />
      <div
        aria-label="Clube de Fidelidade"
        class="logo"
        role="img"
        :style="{ backgroundImage: `url(${logo})` }"
      />
    </div>
    <div class="spacer" />
  </div>
</template>

<style scoped lang="scss">
.badge-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: pointer;
  z-index: 2;
}

.badge {
  position: absolute;
  top: -26px;
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: radial-gradient(
    ellipse 110% 130% at 50% 18%,
    #2c6cfb 0%,
    #1a56d6 48%,
    #0a2a72 100%
  );
  box-shadow:
    0 0 18px rgba(44, 108, 251, 0.55),
    0 4px 20px rgba(10, 42, 114, 0.6);

  .glow {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    box-shadow: inset 0 3px 10px rgba(255, 255, 255, 0.3);
    z-index: 1;
  }

  // Emblema como no Figma: caixa 65.9x56.17 alinhada ao topo do círculo, com o
  // image-fill do Figma (-6.126px -9.243px / 118.159% 138.594% no-repeat). O
  // asset (badge-logo.png) é o do Figma, que já traz padding/glow transparente
  // embutido — por isso o emblema fica contido com margem azul (não estoura).
  .logo {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 2;
    width: 65.9px;
    height: 56.17px;
    transform: translateX(-50%);
    background-position: -6.126px -9.243px;
    background-size: 118.159% 138.594%;
    background-repeat: no-repeat;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.35));
  }
}

.spacer {
  width: 62px;
  height: 30px;
}
</style>
